module.exports = __webpack_public_path__ + "static/img/ET.e505b2a4.svg";